<template lang="pug">
  div
    .form__title
      slot(name='title')
    form.form__body(action='javascript://' v-if='params')
      .form__field
        label.form__label
          | {{ 'Тип планет' }}
        .form__field-body
          cs-multiselect(
            :multiple='false',
            :options='gameTypes',
            :show-labels='true',
            :allow-empty='false',
            track-by='value',
            label="label",
            :placeholder="'Режим'",
            v-model='params.type',
          )
      .form__field
        label.form__label
          | {{ 'Продолжительность игры' }}
        .form__field-body
          cs-multiselect(
            :multiple='false',
            :options='gameDurationOptions',
            :show-labels='false',
            :allow-empty='false',
            track-by='value',
            label='label',
            :placeholder="'Длительность игры'",
            v-model='params.gameDuration',
          )
      .form__field(v-if="gameMode !== 'course'")
        label.form__label
          | {{ 'Планеты' }}
        cs-spin-input(
          :value="params.amountOfPlanets",
          :max="maxAmountOfPlanets",
          :min="3",
          @increase="increaseActions",
          @decrease="decreaseActions",
          @input="params.amountOfPlanets = $event",
        )
      .form__field
        label.form__label
          | {{ 'Усложнение' }}
        cs-checkbox.form-container__select(
            :disabled="disableComplication"
            v-model="params.complication.selected",
        )
        .form__field-body(v-if="params.complication.selected")
            cs-multiselect(
                :multiple='false',
                :options='complicationStepsOptions',
                :show-labels='false',
                :allow-empty='false',
                :placeholder="'Количество ответов для усложнения'",
                v-model='params.complication.steps',
            )
      .form__field
        label.form__label
          | {{ 'Отвлекающие картинки' }}
        cs-checkbox.form-container__select(
          v-model="params.distraction",
        )
      .form__field
        label.form__label
          | {{ 'Подсказка' }}
        cs-checkbox.form-container__select(
          v-model="params.tip",
        )
      divider
      .form-container.form-container_text-centered
          slot(name='parameters', v-if="!($route.params && $route.params.source && $route.params.source === 'homework-template')")
          .help-text
              slot(name='help')
          template(v-if='!usersIds')
              .form-container__footer-buttons
                  cs-button.cancel-button(color="blue", pattern="primary-outline", type='button', @click='cancel')
                      | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                  template(v-if="gameMode && gameMode === 'free-game'")
                      cs-button.save-button(color="blue", type='button', @click='saveGameMode')
                          | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
                  template(v-else)
                      cs-button.save-button(color="blue", type='button', @click='saveGame')
                          | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
          template(v-else)
              .form-container__footer-buttons
                  cs-button.cancel-button(type='button', @click='cancel', pattern="primary-outline", color="blue")
                      | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                  cs-button.save-button(
                      type='button',
                      color="blue",
                      @click='saveGame'
                  )
                      | {{ $i18n.t('trainer.trainer_gameFormSetting_saveDifference') }}
</template>

<script>
    import GameFormMixin from '../../../utils/trainer/GameFormMixin';
    import { getInitParameters } from '../../../utils/trainer/getInitParameters';
    import { mapState } from 'vuex';
    import TrainerGames from '../../../config/trainer';
    import _ from 'lodash';

    export default {
        props: {
            slug: String,
            courseType: String,
            id: [Number, String],
            usersIds: [Array, String],
            homeworkId: [Number, String],
            gameMode: String,
            gameId: [Number, String],
            generatorGameIndex: Number,
            generatorSettings: Boolean,
            levelAnswerDuration: Number,
        },
        mixins: [GameFormMixin],
        mounted() {
            if (this.gameMode === 'free-game') {
                let paramsArray = this.$store.state.trainer.paramsArray;
                if (paramsArray && paramsArray[0] && paramsArray[0].slug === this.slug) {
                    this.paramsArray = _.cloneDeep(paramsArray);
                    this.$emit('playersNumber', this.paramsArray.length);
                    this.params = this.paramsArray[0];
                } else if (this.gamesParameters) {
                    this.$set(
                        this,
                        'params',
                        getInitParameters({
                            slug: this.slug,
                            parameters: {
                                default: _.cloneDeep(this.gamesParameters[this.slug]),
                            },
                        })
                    );
                } else {
                    this.params = _.cloneDeep(TrainerGames.games).find(
                        item => item.slug === this.slug
                    ).parameters.default;
                }
            } else {
                this.setInitParams(this.getKey(this.usersIds));
            }
        },
        data() {
            return {
                complicationStepsOptions: [1, 2, 3],
                gameTypes: [
                    {
                        value: 'colors',
                        label: 'Цвета',
                    },
                    {
                        value: 'digits',
                        label: 'Цифры',
                    },
                    {
                        value: 'mixed',
                        label: 'Смешанный',
                    },
                ],
                gameDurationOptions: [
                    {
                        label: '1 минута',
                        value: 60,
                    },
                    {
                        label: '1.5 минуты',
                        value: 90,
                    },
                    {
                        label: '2 минуты',
                        value: 120,
                    },
                    {
                        label: '2.5 минуты',
                        value: 150,
                    },
                    {
                        label: '3 минуты',
                        value: 180,
                    },
                    {
                        label: '3.5 минуты',
                        value: 210,
                    },
                    {
                        label: '4 минуты',
                        value: 240,
                    },
                    {
                        label: '4.5 минуты',
                        value: 270,
                    },
                    {
                        label: '5 минут',
                        value: 300,
                    },
                ],
                numOfExamples: 15,
                selectedGameType: null,
                selectedGameMode: null,
                params: null,
            };
        },
        computed: {
            ...mapState({
                homework: state => state.trainer.homework,
                gamesParameters: state => state.trainer.gamesParameters,
                user: state => state.auth.user,
            }),
            disableComplication() {
                if (this.params.type.value === 'colors') {
                    return this.params.amountOfPlanets === 9;
                }
                return this.params.amountOfPlanets === 10;
            },
            maxAmountOfPlanets() {
                return this.params && this.params.type.value === 'colors' ? 9 : 10;
            },
        },
        watch: {
            'params.type.value': {
                handler(val) {
                    if (val === 'colors' && this.params.amountOfPlanets >= 9) {
                        this.params.complication.selected = false;
                    }
                },
                deep: true,
            },
            'params.amountOfPlanets': {
                handler(val) {
                    if (this.params?.type.value === 'colors') {
                        if (val === 9) {
                            this.params.complication.selected = false;
                        }
                    } else {
                        if (val === 10) {
                            this.params.complication.selected = false;
                        }
                    }
                },
            },
            maxAmountOfPlanets(val) {
                if (val === 9 && this.params.amountOfPlanets > 9) {
                    this.params.amountOfPlanets = 9;
                }
            },
        },
        methods: {
            secondsLabel(second) {
                return second + ' ' + this.$i18n.t('trainer.trainer_gameFormSettingValue_seconds');
            },
            decreaseActions() {
                if (this.params.amountOfPlanets > 3) {
                    this.params.amountOfPlanets -= 1;
                }
            },
            increaseActions() {
                if (this.params.amountOfPlanets < 10) {
                    this.params.amountOfPlanets += 1;
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    .form-container {
        width: 100%;
        max-width: 820px;
        margin: 0 auto;
    }

    .form-container_text-centered {
        text-align: center;
    }

    .form-container__footer-buttons {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 20px;
        @media screen and (max-width: 767px) {
            flex-direction: column;
        }
    }

    .cancel-button {
        width: 200px;
    }

    .save-button {
        width: 200px;
        margin-left: 20px;
        @media screen and (max-width: 767px) {
            margin: 20px 0 0 0;
        }
    }

    .form__title {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        margin-bottom: 25px;
    }

    .form__body {
        width: 100%;
        box-sizing: border-box;
        @include media($lg) {
            padding: 0 4.5%;
        }
    }

    .form__field {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: center;
        }
        @include media($lg) {
            padding: 0 10%;
        }
        @include media($xlg) {
            padding: 0 13%;
        }
    }
    .form__label {
        min-width: 0;
        font-size: 16px;
        line-height: 19px;
        margin-right: 20px;
        margin-bottom: 0.5rem;
        @include media($md) {
            width: 8em;
            margin-bottom: 0;
            text-align: right;
        }
        @include media($xlg) {
            max-width: none;
            min-width: 13em;
        }
    }

    .form__field-body {
        flex-grow: 5;
    }

    .form__buttons {
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        @include media($md) {
            flex-direction: row;
        }
    }

    .form__button {
        margin: 10px 50px;
        @include media($md) {
            margin: 0 10px;
        }
    }
</style>
